import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    company : {},
    catcherId: "", // holds main account catcherId
    catcherEmail: "",
    privacy_text: "",
    company_name: "",
    is_ai_feature_on: false,
    invitationCatcherId: "" // holds catcherId of account which created interview
};

const companySlice = createSlice({
    name:'company',
    initialState,
    reducers : {
        setCompany : (state, {payload}) => {
            state.company = payload;
        },
        setCatcherId : (state, {payload}) => {
            state.catcherId = payload;
        },
        setCatcherEmail : (state, {payload}) => {
            state.catcherEmail = payload;
        },
        setPrivacyText : (state, {payload}) => {
            state.privacy_text = payload;
        },
        setCompanyName : (state, {payload}) => {
            state.company_name = payload;
        },
        setIsAiFeatureOn : (state, {payload}) => {
            state.is_ai_feature_on = payload;
        },
        setInvitationCatcherId : (state, {payload}) => {
            state.invitationCatcherId = payload;
        }
    }
})

export const {setCompany, setCatcherId, setPrivacyText, setCompanyName, setCatcherEmail, setIsAiFeatureOn, setInvitationCatcherId} = companySlice.actions;

export const getCompany = (state) => state.company.company;
export const getCatcherId = (state) => state.company.catcherId;
export const getCatcherEmail = (state) => state.company.catcherEmail;
export const getPrivacyText = (state) => state.company.privacy_text;
export const getCompanyName = (state) => state.company.company_name;
export const getIsAiFeatureOn = (state) => state.company.is_ai_feature_on;
export const getInvitationCatcherId = (state) => state.company.invitationCatcherId;

export default companySlice.reducer;